import { get } from 'lodash';

const styles = (theme) => ({
  content: {
    marginBottom: 0,
    marginTop: 0,
    '&.Mui-expanded': {
      margin: 0,
      minHeight: 40,
    },
  },
  errorIcon: {
    color: get(theme, 'color.error'),
  },
  expandIcon: {
    paddingBottom: 4,
    paddingTop: 4,
  },
  expansionPanelDetails: {
    backgroundColor: get(theme, 'color.background'),
    padding: '12px 42px 24px 42px',
  },
  expansionPanelDetailsContent: {
    backgroundColor: get(theme, 'color.uiBackground'),
    padding: '24px 16px 36px 16px',
    width: '100%',
  },
  iconRoot: {
    marginTop: 4,
    color: get(theme, 'color.primaryButtonBackground'),
  },
  labelContainer: {
    marginTop: 5,
    padding: 5,
  },
  missingFieldsContainer: {
    display: 'inline-flex',
    marginLeft: 16,
  },
  panelRoot: {
    backgroundColor: get(theme, 'color.uiBackground'),
    border: `1px solid ${get(theme, 'color.borderColor')}`,
    borderLeft: 'none',
    borderRight: 'none',
    boxShadow: 'none',
    '&.Mui-expanded': {
      marginBottom: 0,
      marginTop: 0,
    },
    '& .MuiExpansionPanelSummary-expandIcon': {
      color: get(theme, 'color.link'),
    },
  },
  summaryContainer: {
    display: 'flex',
  },
  summaryRoot: {
    flexGrow: 1,
    minHeight: 40,
    '&.Mui-expanded': {
      marginTop: 4,
      minHeight: 40,
    },
  },
  templateErrorLabel: {
    color: get(theme, 'color.bodyText'),
  },
  templateErrorText: {
    color: get(theme, 'color.link'),
  },
  unDraggableTemplate: {
    visibility: 'hidden',
  },
  primaryButton: {
    marginLeft: 10,
    textTransform: 'none',
    color: get(theme, 'color.primaryButtonBackground'),
    backgroundColor: get(theme, 'color.primaryButtonText'),
    borderColor: get(theme, 'color.primaryButtonBackground'),
    lineHeight: get(theme, 'lineHeight.lh20'),
    border: '1px solid',
    '&:focus': {
      outlineOffset: "1px",
      outline: `1px double ${get(theme, 'color.primaryButtonBackground')}`,
    },
  },
  headerAndCopyPastePanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  h4NoMargin: {
    margin: '0px !important',
  },
});

export default styles;